<template>
  <!-- <div style="height: 310px" ref="chart"></div> -->
  <div id="order-care-bar-chart" class="chartheight" :style="{ width: '100%' }"></div>
</template>

<script>
const colorArr = [
  "#4878FF",
  "#4CDFC0",
  "#F3F3F3",
  "#FFB95E",
  "#5882FB",
  "#49C568",
  "#AEB3F1",
  "#CCCCCC",
];
export default {
  props: {
    // ageNum: null,
    year: null,
  },
  data() {
    return {
      myCharts: null,
      chartData: [
        // {
        //   value: this.ageNum[0].count,
        //   name: "男",
        //   itemStyle: { color: "#11CE99" },
        // },
        // {
        //   value: this.ageNum[1].count,
        //   name: "女",
        //   itemStyle: { color: "#FF872F" },
        // },
        // {
        //   value: this.ageNum[2].count,
        //   name: "未识别",
        //   itemStyle: { color: "#5882FB" },
        // },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.drawOrderCareBar();
      window.addEventListener("resize", () => {
        this.myCharts.resize();
      });
    });
    // this.$nextTick(() => {
    //   this.chartData = this.ageNum.map((item, index) => {
    //     return {
    //       value: item.count,
    //       name: item.name,
    //       itemStyle: { color: colorArr[index] },
    //     };
    //   });
    //   this.initChart();
    //   window.addEventListener("resize", () => {
    //     this.myCharts.resize();
    //   });
    // });
  },
  methods: {
    // initChart() {
    //   this.myCharts = this.$echarts.init(this.$refs.chart);
    //   let arr = [];
    //   this.chartData.forEach((item, index) => {
    //     if (item.value != 0) {
    //        arr.push(item);
    //       // this.chartData.splice(index, 1);
    //     }
    //   });
    //   this.setOptions(arr);
    // },
    // setOptions(data) {
    //   let options = {
    //     // 提示框组件
    //     tooltip: {
    //       trigger: "item",
    //       formatter: "{a} <br/>{b}: {c} 人 ({d}%)",
    //     },
    //     legend: {
    //       type: "scroll",
    //       // orient: "vertical",
    //       // left: -5,
    //       // top: 50,
    //       bottom: 10,
    //       icon: "circle",
    //       data: data.map((i) => i.name),
    //       itemWidth: 8,
    //       itemHeight: 8,
    //     },
    //     // 系列列表。每个系列通过 type 决定自己的图表类型
    //     series: {
    //       name: "年龄",
    //       type: "pie",
    //       radius: ["45%", "65%"],
    //       avoidLabelOverlap: true,
    //       label: {
    //         show: true,
    //         // position: 'center'
    //       },
    //       emphasis: {
    //         label: {
    //           show: true,
    //           fontSize: "16",
    //           fontWeight: "bold",
    //         },
    //       },
    //       labelLine: {
    //         show: true,
    //       },
    //       data: data,
    //     },
    //     itemStyle: {
    //       emphasis: {
    //         shadowBlur: 10,
    //         shadowOffsetX: 0,
    //         shadowColor: "rgba(0, 0, 0, 0.5)",
    //       },
    //     },
    //   };
    //   this.myCharts.setOption(options);
    // },

    //绘制柱状图
    drawOrderCareBar() {
      let orderCareBarChart = this.$echarts.init(
        document.getElementById("order-care-bar-chart"),
        "light"
      ); //初始化echats实例
      var dataReset = [
        { value: this.year[0].count },
        { value: this.year[1].count },
        { value: this.year[2].count },
        { value: this.year[3].count },
        { value: this.year[4].count },
        { value: this.year[5].count },
        { value: this.year[6].count },
      ];
      var datasetReset = [
        "15岁以下",
        "16-25岁",
        "26-35岁",
        "36-45岁",
        "46-55岁",
        "56岁以上",
        "未识别",
      ];
      orderCareBarChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} 人",
        },
        xAxis: {
          type: "category",
          data: datasetReset,
          axisLabel: {
            interval: 0, rotate:45
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#666666",
            },
          },
           axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        series: [
          {
            type: "bar",
            barWidth: 20, //柱图宽度
            legendHoverLink: true,
            itemStyle: {
              normal: {
                label: {
                  // show: true, //开启显示
                  // position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#666666",
                    fontSize: 14,
                  },
                },
                color: function (params) {
                  var colorList = [
                    "#4878FF",
                    "#4878FF",
                    "#4878FF",
                    "#4878FF",
                    "#4878FF",
                    "#4878FF",
                    "#4878FF",
                  ];
                  return colorList[params.dataIndex];
                },
              },
            },
            data: dataReset,
          },
        ],
      });
      window.onresize = function () {
        orderCareBarChart.resize();
      };
    },
  },
};
</script>

<style scoped lang="scss">
.chartheight{
      height: 310px !important;
            @media screen and (max-width: 1400px){
              margin-top: -20px;
          height: 280px !important;
        }
          @media screen and (max-width: 1340px){
            margin-top: -10px;
          height: 230px !important;
        }
}
// .order_money {
//   height: 100%;
//   background: rgba(255, 255, 255, 1);
//   box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.06);
//   border-radius: 6px;
//   overflow: hidden;
//   .head {
//     box-sizing: border-box;
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     height: 54px;
//     padding: 0 24px;
//     span {
//       color: #2e3458;
//       font-size: 16px;
//       font-weight: 800;
//     }
//     img {
//       width: 18px;
//       height: 18px;
//       cursor: pointer;
//     }
//     border-bottom: 1px solid #f6f6f6;
//   }
//   .content {
//     height: 306px;
//   }
// }
</style>
